// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2mHSg","skewer":"_3waRq","root":"_1mMPu","background":"_32MZw","logo":"uFAiG","newsletter":"_3QxCU","nav":"_3tWkb","identities":"LJCAw","ps":"_1vIJw"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Default/Footer/Footer.sass
// module id = ./src/layouts/Default/Footer/Footer.sass
// module chunks = 6